/* The homepage gallery wall (LandingV2): which clips it shows and where each
   one sits. Tiles load CDN + narrative-video-<u>.mp4 / narrative-thumb-<u>.jpg;
   clicking one opens the demo popup for the matching DEMO_MUSIC_VIDEOS entry
   (wallDemos.ts). */

export type WallClip = {
  u: string;
  dur: string;
  title: string;
  sub: string;
  ar: string;
  z?: number;
  /** Featured creator: placed in the middle of the wall, where people look. */
  f?: 1;
};

// Featured, in placement order (the first takes the most central slot): the
// Oct 7 2026 creative review's picks, best first (SHOWCASE_DEMO_ORDER), then
// the videos published by Dan Olds (Amber Song) and James (MetronomiX, Already
// Gone). Kept first so the list reads the same as the wall.
// prettier-ignore
export const CLIPS: WallClip[] = [
  { u: "7b3e310f-3852-4104-8cbf-f69983cf14f7", dur: "4:28", title: "Kaleidoscope Mind", sub: "Cloudlight Reverie", ar: "16/9", f: 1 },
  { u: "8e6e411c-1b45-4520-975c-f7075d242e4d", dur: "4:04", title: "Blonde", sub: "Liquid Chrome Futurism", ar: "9/16", f: 1 },
  { u: "b41472bb-7b03-4915-80ad-1d605860cd24", dur: "3:58", title: "Mind Flipper", sub: "Desert Mirage", ar: "16/9", f: 1 },
  { u: "f12e6bf8-7c24-4e2a-92a0-9691e123d734", dur: "3:01", title: "Aisle 9", sub: "Cinematic", ar: "9/16", f: 1 },
  { u: "5e7b2167-d79d-4989-b952-12f15ddc2ebe", dur: "5:08", title: "Masochistic Love Ballet", sub: "HD Digital Film", ar: "16/9", f: 1 },
  { u: "173fbe0e-3fb5-496c-a32e-a8e4be34155f", dur: "4:02", title: "Armour Made of Lies", sub: "Liminal Motel", ar: "16/9", f: 1 },
  { u: "665e812e-ddf5-4da4-9ad6-f32c1d7c2090", dur: "2:54", title: "Lights Out", sub: "HD Digital Film", ar: "16/9", f: 1 },
  { u: "929c879a-d0b5-418c-8ffd-878b084896f0", dur: "3:12", title: "Wir haben", sub: "Cinematic", ar: "16/9", f: 1 },
  { u: "e8ad1e0a-1445-4eee-ac10-e7ff88ea7780", dur: "1:00", title: "Nothing Serious", sub: "Euphoria Style Inspired", ar: "16/9", f: 1 },
  { u: "55b9704f-ab29-461b-a3ce-776c1e5d8fd9", dur: "2:56", title: "I Taste Only Blood", sub: "Ink Wash Memory", ar: "16/9", f: 1 },
  { u: "cf0f4f84-0e45-4813-b22d-868d81c51694", dur: "1:11", title: "Bouge Bouge Bébé", sub: "3D Animation", ar: "16/9", f: 1 },
  { u: "48542829-b9c4-4f8f-a2dc-edf3a5ed3269", dur: "3:04", title: "Right Under the Storm", sub: "HD Digital Film", ar: "16/9", f: 1 },
  { u: "4c6413f9-ed41-404a-9ec0-39f062ab5bb6", dur: "0:29", title: "Bad Times", sub: "K-Pop Performance Editorial", ar: "9/16", f: 1 },
  { u: "64e598bd-eac5-440a-a516-3ce0bba48a0d", dur: "1:13", title: "Moonlit Making", sub: "Anime", ar: "9/16", f: 1 },
  { u: "305d7946-b389-4c6c-9be5-2601c698a746", dur: "3:47", title: "Blind Leading the Blind", sub: "Wong Kar-wai Inspired", ar: "16/9", f: 1 },
  { u: "85811574-326c-43ae-aefb-7c1056c5533e", dur: "2:56", title: "Earth Is Burning", sub: "Collage Pop Diary", ar: "9/16", f: 1 },
  { u: "541117ef-74d3-4405-8751-7535dd62ac3f", dur: "4:29", title: "Not Alone Beneath the White Sky", sub: "Desert Mirage", ar: "16/9", f: 1 },
  { u: "1e2a0e8a-153e-4f5b-ad33-294da962b943", dur: "4:22", title: "Heaven", sub: "Cloudlight Reverie", ar: "16/9", f: 1 },
  { u: "8b62d143-84cc-4325-a5b1-bf7866a17252", dur: "3:35", title: "Already Gone", sub: "HD Digital Film", ar: "16/9", f: 1 },
  { u: "ebe5a4bc-c755-4143-aa5b-27c4467963a8", dur: "4:03", title: "Love Street", sub: "HD Digital Film", ar: "16/9", f: 1 },
  { u: "8ed8c341-2582-466b-a1fb-8a0a1b823765", dur: "5:10", title: "Down The Road", sub: "HD Digital Film", ar: "16/9", f: 1 },
  { u: "0223f398-94cb-4bba-b03f-30dc78528ffd", dur: "4:09", title: "The Path of Life", sub: "HD Digital Film", ar: "16/9", f: 1 },
  { u: "4b679f57-0dfa-4ffb-a540-96324a487849", dur: "4:06", title: "Crooked Roads/Highway", sub: "HD Digital Film", ar: "16/9", f: 1 },
  { u: "fba31b5e-0a28-418d-833a-f7c3393552d0", dur: "0:51", title: "Engine On", sub: "HD Digital Film", ar: "16/9" },
  { u: "b5769b43-eaeb-443f-9db9-80a36750661a", dur: "0:39", title: "Rhythmic Liberation", sub: "K-Pop Performance Editorial", ar: "16/9" },
  { u: "eafb79a1-1e60-4461-a68d-a13e440d1365", dur: "0:50", title: "Color Field: Dissolve", sub: "Grainy Gradient", ar: "9/16" },
  { u: "3840eb9f-9f41-44f7-bb00-ccf1e9bbeb0a", dur: "0:40", title: "Paper Boats & City Lights", sub: "Love Actually Inspired", ar: "16/9" },
  { u: "60aa6c89-4a74-4de7-aabe-8c5810c64fc7", dur: "1:12", title: "Skyline Chase: A Chromatic Ascent", sub: "Euphoria Inspired", ar: "16/9" },
  { u: "9a1fb7a0-b13a-414c-8839-acd2651344f0", dur: "0:35", title: "Bunny's Pastel Day", sub: "Soft Toybox 3D", ar: "16/9" },
  { u: "30418047-390e-4366-b627-2764004e36bf", dur: "0:35", title: "Midnight Almost", sub: "Wong Kar-wai Inspired", ar: "16/9" },
  { u: "fc64d50f-1875-4f9f-8327-2aac78e9ec2b", dur: "0:59", title: "The Letter Never Sent", sub: "Shunji Iwai Inspired", ar: "9/16" },
  { u: "319a3dca-2402-49e5-a3b3-133b17af1bd5", dur: "0:48", title: "The Last Confession", sub: "Classic Film Noir", ar: "16/9" },
  { u: "05a399b9-83da-448c-b15c-da952b31f2b1", dur: "0:39", title: "水墨月", sub: "Ink Wash Memory", ar: "16/9" },
  { u: "e128a574-f2b0-4b1f-a991-f93a03049278", dur: "0:55", title: "The Ultimate Guide: Curtis Home Inspections", sub: "HD Digital Film", ar: "16/9" },
  { u: "743e313f-642f-473d-8ece-3ac7c9f19f27", dur: "3:29", title: "Strumming On", sub: "HD Digital Film", ar: "16/9" },
  { u: "9f2516c9-9508-4e81-bccb-485a9abd8948", dur: "4:24", title: "Spirits Call Me Home", sub: "HD Digital Film", ar: "16/9" },
  { u: "a9b21c5d-0b8c-481f-a602-cfd99b0227ba", dur: "1:01", title: "Static Bound", sub: "90s MTV Aesthetic", ar: "9/16" },
  { u: "5e53bfb8-edf7-4be4-a8a2-3849b6f4352b", dur: "4:14", title: "Love Finds You Where You Are", sub: "Classic Film Noir", ar: "16/9" },
  { u: "49294bc9-d2cb-4ee1-bff8-545ddfb0d93e", dur: "4:09", title: "The Last Stop", sub: "Desert Mirage", ar: "16/9" },
  { u: "367e68cd-01a9-4de0-a350-260181b4e240", dur: "4:41", title: "We Outside: Neon Friday", sub: "Euphoria Style Inspired", ar: "16/9" },
  { u: "0d3befdc-7037-4230-9ec0-1a1d41aa789a", dur: "3:57", title: "Unity_retake", sub: "Grainy Gradient", ar: "16/9" },
  { u: "72da0757-e66e-4afe-bb88-af333c2fb427", dur: "4:38", title: "Once in a Lifetime: An Urban Love Story", sub: "Love Actually Inspired", ar: "16/9" },
  { u: "385b13b8-90a2-446b-9511-6e6960010d2e", dur: "2:50", title: "Años Veinte: The Golden Echo", sub: "HD Digital Film", ar: "16/9" },
  { u: "e4dd833d-7cb4-4999-8013-0ebcccbcd8fc", dur: "3:00", title: "Big Bad Wolf: Afterhours Payroll", sub: "Afterhours Gloom", ar: "16/9" },
  { u: "b51cb4b6-fcde-4c7a-b186-a110046d1408", dur: "1:34", title: "Verdigris Afterglow", sub: "Saturated 35mm Film", ar: "9/16" },
  { u: "703ff102-dea9-4459-8db4-9318ebe6a5e4", dur: "2:21", title: "Northern Regime: The Afterhours Score", sub: "Afterhours Gloom", ar: "16/9" },
  { u: "e9e8b577-ff0b-438d-b223-89c921289660", dur: "4:14", title: "The Horizon's Kiss", sub: "Love Actually Inspired", ar: "16/9" },
  { u: "49baa8ae-b205-4cfb-aebb-dd54dee684fe", dur: "3:11", title: "Smooth Vibe: The Studio Sessions", sub: "Wong Kar-wai Inspired", ar: "16/9" },
  { u: "e66ca6be-cb7b-40dc-83a3-f96ddf3a8a4a", dur: "3:41", title: "Floating Home", sub: "Cloudlight Reverie", ar: "16/9" },
  { u: "f20dce55-8c17-4fa3-85ab-c21118e27f75", dur: "2:17", title: "AudioJet Saloon 4.1.1: The Cyber-Can-Can", sub: "Metro Tech Noir", ar: "16/9" },
  { u: "a46cdbbf-01ab-4ca9-a530-a7fdfd590d7d", dur: "4:44", title: "The Cowboy's Prayer", sub: "HD Digital Film", ar: "16/9" },
  { u: "5a7fc3e0-7d6a-4659-b5aa-24eae7a0674a", dur: "2:41", title: "Benefits in the Sun", sub: "HD Digital Film", ar: "16/9" },
  { u: "fb186718-d1bf-4e6e-965f-1428ae2f7459", dur: "1:36", title: "Sweet Caffeine Rewind", sub: "Retro VHS", ar: "9/16" },
  { u: "4467353a-20ec-4a49-b76a-7fe970d5bf9d", dur: "4:43", title: "Dreaming of the Mirage", sub: "Desert Mirage", ar: "16/9" },
  { u: "977f4243-10fd-4035-a989-e8ce75deec3d", dur: "2:42", title: "Sheldon McCann: Chrome Celebration", sub: "Liquid Chrome Futurism", ar: "16/9" },
  { u: "8d98c0d1-4e54-414b-a6ae-a9b5ea60e2f0", dur: "4:29", title: "Only Your Presence", sub: "HD Digital Film", ar: "16/9" },
  { u: "c246bded-e482-4908-91ee-e5762c83e56d", dur: "4:14", title: "Snowbelt Surprise", sub: "Holiday Atmosphere", ar: "16/9" },
  { u: "19b17c4f-4964-4195-9c25-0379204b2777", dur: "2:22", title: "Yéyé Retrospective", sub: "HD Digital Film", ar: "16/9" },
  { u: "476807de-e26b-4949-a6d6-e4b6f98707a7", dur: "2:22", title: "Détache-toi", sub: "HD Digital Film", ar: "16/9" },
  { u: "7203027c-9b23-49ac-be8d-8abff2536411", dur: "4:33", title: "The Rain Remembers", sub: "Wong Kar-wai Inspired", ar: "16/9" },
  { u: "3d6bfc63-dd32-42fb-b094-b5f7b65787b2", dur: "1:01", title: "Neon Exit", sub: "Y2K Glossy Futuristic", ar: "9/16" },
  { u: "d4d3b098-2d3c-4f82-81b5-b28e38ddb0a8", dur: "3:21", title: "Redline Signal", sub: "Metro Tech Noir", ar: "16/9" },
  { u: "9d69db14-5c78-4e7b-9d22-13343e2101a5", dur: "4:03", title: "Magical Brazil: The Global Odyssey", sub: "HD Digital Film", ar: "16/9" },
  { u: "d4150c62-ace2-470d-9b12-243de65f9b3b", dur: "2:48", title: "Alice in Wonder Rave: Pantofelek o Północy", sub: "HD Digital Film", ar: "16/9" },
  { u: "08229c1c-e5a0-4c03-8fcd-88f82852ec72", dur: "2:20", title: "Te Vreau - A Winter Memory", sub: "Wong Kar-wai Inspired", ar: "16/9" },
  { u: "6084317f-f2eb-4748-9e02-f28212f3c3e4", dur: "1:30", title: "Neon Ghost Arcade", sub: "Retro VHS", ar: "9/16" },
  { u: "08678045-e603-43b9-bb7a-03dff94c322b", dur: "1:50", title: "The Sun Burns Out", sub: "Cinematic", ar: "9/16" },
  { u: "4ab7ecfa-2c21-41db-b26f-36ce8a5ca42e", dur: "1:52", title: "Sweet-Talking Remedy", sub: "Editorial", ar: "9/16" },
  { u: "0139be73-9d58-45c2-a3df-61fdaeef5a05", dur: "1:15", title: "Compass in the Neon Rain", sub: "Cyber-Noir", ar: "9/16" },
  { u: "ba722ca6-7e20-450a-8ec2-3a4ff2e98478", dur: "1:22", title: "Static in the Midnight City", sub: "French New Wave Film", ar: "9/16" },
  { u: "2f4f93f5-d83b-42f6-bcd6-b72d7af4b801", dur: "1:10", title: "Electric Current", sub: "Vogue Editorial Studio", ar: "9/16" },
  { u: "7d401f9f-aa57-497b-bb78-5607a0fa4dc3", dur: "1:10", title: "Double Take: Digital Eyes", sub: "Y2K Cyber-Glitch", ar: "9/16" },
];

// landing-v2.css's desktop .wall sizes (--tw / --gap).
const WALL_TILE_WIDTH = 236;
const WALL_GAP = 14;

/**
 * Tile width, gap and column count from the wall's computed `--tw` / `--gap`
 * and the viewport width. Those custom properties come back empty when the
 * stylesheet isn't applied: a crawler that drops stylesheets (Otterly's
 * proxied renderer does), or a stylesheet that failed or hadn't applied when
 * the page script ran (most of the crash reports came from Safari). The wall
 * then lays out with the desktop sizes instead of NaN columns.
 */
export function wallMetrics(
  tileWidthCss: string,
  gapCss: string,
  viewportWidth: number,
): { tw: number; gap: number; cols: number } {
  const twPx = parseFloat(tileWidthCss);
  const gapPx = parseFloat(gapCss);
  const tw = Number.isFinite(twPx) && twPx > 0 ? twPx : WALL_TILE_WIDTH;
  const gap = Number.isFinite(gapPx) && gapPx >= 0 ? gapPx : WALL_GAP;
  const width = Number.isFinite(viewportWidth) && viewportWidth > 0 ? viewportWidth : 0;
  return { tw, gap, cols: Math.max(6, Math.ceil(width / (tw + gap)) + 2) };
}

/** The column whose tiles sit under the middle of a wall `width` px wide,
 *  before it has drifted. */
export function wallCenterColumn(width: number, tileWidth: number, gap: number, cols: number): number {
  const i = Math.round((width / 2 - tileWidth / 2) / (tileWidth + gap));
  return Math.min(cols - 1, Math.max(0, i));
}

/**
 * Lays the clips out as `cols` columns of three tiles, top to bottom. Each
 * column holds one portrait (row `i % 3`, so the tall tile steps down across
 * the wall) and two landscapes. Featured clips take the slots nearest the
 * middle: the centre column first, then alternately right and left of it
 * (right first, since the wall drifts left and a column right of centre is
 * still ahead of the eye). Featured landscapes fill the middle row before the
 * top and bottom; featured portraits take those same columns' portrait slots,
 * so the first few featured clips of either shape sit together.
 * Everything else fills in CLIPS order.
 */
export function planWallColumns(clips: WallClip[], cols: number, center: number): WallClip[][] {
  // A NaN column count used to reach grid[NaN][k] and throw, which took "/"
  // down to the fatal error screen; a NaN centre would never fill `order`.
  if (!Number.isFinite(cols) || cols < 1 || !clips.length) return [];
  cols = Math.floor(cols);
  const isPortrait = (c: WallClip) => c.ar === "9/16";
  const featured = clips.filter((c) => !isPortrait(c) && c.f);
  const featuredPort = clips.filter((c) => isPortrait(c) && c.f);
  const land = clips.filter((c) => !isPortrait(c) && !c.f);
  const grid: (WallClip | null)[][] = Array.from({ length: cols }, () => [null, null, null]);

  const order = [Number.isFinite(center) ? Math.min(cols - 1, Math.max(0, Math.round(center))) : 0];
  for (let d = 1; order.length < cols; d++) {
    if (order[0] + d < cols) order.push(order[0] + d);
    if (order[0] - d >= 0) order.push(order[0] - d);
  }
  let fi = 0;
  let fpi = 0;
  for (const i of order) {
    for (const k of [1, 0, 2]) {
      if (k === i % 3) {
        if (fpi < featuredPort.length) grid[i][k] = featuredPort[fpi++];
      } else if (fi < featured.length) {
        grid[i][k] = featured[fi++];
      }
    }
  }

  const rest = [...featured.slice(fi), ...land];
  const leftPort = [...featuredPort.slice(fpi), ...clips.filter((c) => isPortrait(c) && !c.f)];
  const port = leftPort.length ? leftPort : featuredPort;
  let li = 0;
  let pi = 0;
  const nextL = () => rest[li++ % rest.length];
  const nextP = () => (port.length ? port[pi++ % port.length] : nextL());
  return grid.map((col, i) => col.map((c, k) => c ?? (k === i % 3 ? nextP() : nextL())));
}
